//
//

import * as axios from "@/store/http";
import * as auth from "@/utils/auth";
import {
    resetMsg
} from '@/js/resetMessage.js';
export default {
    name: "portalCommFileUpload",
    props: {},
    data() {
        return {
            doUpload: "api/api/portalFile/upload",
            doUploadChunk: "api/api/portalFile/uploadChunk",
            removeUrl: "api/api/portalFile/delefilebyId",
            downloadUrl: "api/api/portalFile/download",
            uploadMergeUrl:"/api/portalFile/uploadMergeFile",//合并URL
            getdoctype : "api/api/portalFile/getDocuTypeInfo",
            filetype: "",
            showFileList: [],
            dialogVisible: false, //控制弹出框的显示
            limitNum: 999, //最大允许上传个数
            acceptType: "",
            tagName: "",
            tabName: "",
            docuTypeId: "",
            btype: "",
            maxSize: "", //最大大小
            chunkSize:"",//分片大小
            ifChunkSize:"",//附件大小大于多少时进行分片
            //uploadSuccess:false,//用于判断文件是否已上传到服务端
            btnChangeEnable: false,
            showcancel: true, //判断是否展示撤销按扭，如果已点击上传服务器了，则不展示
            showmultiple: true, //是否允许多选
        };
    },
    methods: {
        openUpload() {
            let flag = true;
            if (this.checkUploadkFun) {
                flag = this.checkUploadkFun()
            }
            this.dialogVisible = flag;
        },
        beforeAvatarUpload(file) { //上传前再判断下文件类型
            if (this.maxSize != "" && this.maxSize != undefined) {
                if (this.cal.accSub(file.size, this.maxSize) > 0) {
                    resetMsg.warning(this.$t('contractcheck.checkMaxSize').replace("{0}", parseInt(this.maxSize) / 1024 / 1024));
                    this.removeFileList(file.uid);
                    return false;
                }
            }
            let fileType = file.name.substring(file.name.lastIndexOf('.') + 1); //获取文件类型
            let type = this.acceptType;
            if (type != undefined && type != "" && type.indexOf(fileType) == -1) {
                this.$message.warning(this.$t('contractcheck.filetype') + this.acceptType);
                this.removeFileList(file.uid);//文件类型不对时移走相对应文件
                return false;
            }
            this.btnChangeEnable = true;
            return true;
        },
        removeFileList(uid) { //根据uid移走文件
            if (this.showFileList.length > 0) {
                for (let i = 0; i < this.showFileList.length; i++) {
                    if (this.showFileList[i].uid == uid) {
                        this.showFileList.splice(i, 1);
                    }
                }
            }
        },
        handleAvatarSuccess(res, file, fileList) {
        },
        handleChange(file, fileList) { //文件状态改变时的钩子，添加文件、上传成功和上传失败时都会被调用
            let flag = true;
            if (this.showFileList.length > 0) {
                for (let i = 0; i < this.showFileList.length; i++) {
                    if (this.showFileList[i].uid == file.uid) {
                        this.showFileList[i] = file;
                        flag = false;
                    }
                }
            }
            if (flag) {
                this.showFileList.push(file);
            }
        },
        clicka(file) {
            let params = {
                record: {
                    filename: file.name,
                    url: file.url,
                    btype: this.btype,
                    keyval: this.keyval,
                    tagname: this.tagName,
                    tabname: this.tabName,
                    docutypeid: this.docuTypeId,
                }
            };
            axios.posttype(this.downloadUrl, params, "arraybuffer").then(res => {
                let blob = new Blob([res.data]);
                let url = window.URL.createObjectURL(blob); //表示一个指定的file对象或Blob对象
                let a = document.createElement("a");
                document.body.appendChild(a);
                a.href = url;
                a.download = file.name; //命名下载名称
                a.click(); //点击触发下载
                window.URL.revokeObjectURL(url); //下载完成进行释放
            });
        },
        beformRemove(file, fileList) {
            let uId = file.uid;
            return true;
        },
        delUploadFile(file, rowindex) { //删除附件
            let params = {
                delfileids: [file.uuid]
            };
            this.axios
                .post(this.removeUrl, params)
                .then(({
                    data
                }) => {
                    if ("1" === data.code) {
                        this.tipSuccess(this.$t("common.delsuccess"));
                        this.showFileList.splice(rowindex, 1);
                    }
                })
                .catch(error => console.log(error));
        },
        handleExceed(files, fileList) { //超过限制数量时弹出提示
            let msg = this.$t('contractcheck.filenum') + this.limitNum;
            this.$message.warning(msg);
        },
        submitUpload() {
            this.$refs.upload.submit();
        },
        async uploadFile(option) {
            let formData = new FormData();
            formData.append("file", option.file);
            formData.append("isAvatar", "0");
            formData.append("btype", this.btype);
            formData.append("accountid", this.accountid);
            formData.append("tagname", this.tagName);
            formData.append("tabname", this.tabName);
            formData.append("docutypeid", this.docuTypeId);
            formData.append("keyval", this.keyval);
            let uid = option.file.uid;
            this.showProgress(uid);
            let config = {
                onUploadProgress: ProgressEvent => {
                    let progressPercent = parseInt((ProgressEvent.loaded / ProgressEvent.total * 100));
                    this.setProgressPercent(uid, progressPercent);
                }
            }
            await axios
                .postUpload2(this.doUpload, formData, config)
                .then(res => {
                    if ("1" === res.data.code) {
                        this.setFileId(uid, res.data.data.fileid);
                    }
                })
                .catch(error => {
                    console.log("[error] :", error);
                });
        },
        loadFile(fileInfo, rowIndex) { //带进度条下载
            //设置文件信息
            let fileName= fileInfo.filename;
            if(!this.isNotNullOrEmpty(fileName)){
                fileName= fileInfo.name;
            }
            let params = {
                record: {
                    fileid: fileInfo.fileid,
                    filename: fileName,
                    url: fileInfo.upfile
                }
            };
            let fileSize = fileInfo.filesize;
            this.$set(fileInfo, "ifDownProgress", true);
            let config = {
                onDownloadProgress: ProgressEvent => {
                    let progressPercent = (ProgressEvent.loaded / fileSize * 100).toFixed(2);
                    if (progressPercent >= 100) {
                        progressPercent = 99;
                    }
                    this.$set(fileInfo, "downpercentage", parseInt(progressPercent));
                }
            };
            this.axios
                .posttype2(this.downloadUrl, params, "arraybuffer", config)
                .then(res => {
                    let blob = new Blob([res.data]);
                    let url = window.URL.createObjectURL(blob); //表示一个指定的file对象或Blob对象
                    let a = document.createElement("a");
                    document.body.appendChild(a);
                    a.href = url;
                    a.download = fileName; //命名下载名称
                    a.click(); //点击触发下载
                    window.URL.revokeObjectURL(url); //下载完成进行释放
                    document.body.removeChild(a);
                    this.$set(fileInfo, "downpercentage", 100);
                    let _this=this;
                    setTimeout(function()  {
                        _this.$set(fileInfo, "ifDownProgress",false);
                    }, 2000);
                })
                .catch(error => console.log(error));
        },
        showProgress(uid) { //设置百分比
            if (this.showFileList.length > 0) {
                for (let i = 0; i < this.showFileList.length; i++) {
                    if (this.showFileList[i].uid == uid) {
                        this.$set(this.showFileList[i], "showProgress", true);
                    }
                }
            }
        },
        setProgressPercent(uid, progressPercent) { //设置百分比
            if (this.showFileList.length > 0) {
                for (let i = 0; i < this.showFileList.length; i++) {
                    if (this.showFileList[i].uid == uid) {
                        this.$set(this.showFileList[i], "percentage", progressPercent);
                    }
                }
            }
        },
        setFileId(uid, fileId) { //设置回写的附件ID
            if (this.showFileList.length > 0) {
                for (let i = 0; i < this.showFileList.length; i++) {
                    if (this.showFileList[i].uid == uid) {
                        this.$set(this.showFileList[i], "fileid", fileId);
                        let _this=this;
                        setTimeout(function()  {
                            _this.$set(_this.showFileList[i], "showProgress", false);
                        }, 2000);
                    }
                }
            }
        },
    }
}



// WEBPACK FOOTER //
// ./src/pcpage/hr/recruitment/portal/component/portalCommFileUpload.vue